import React from "react";
import styled from "styled-components";
import Window from "../Window";
import PixelIcon from "../PixelIcon";

// The front door: a Win95-style logon dialog over the bare desktop. Its
// one job besides mood is being the user gesture that unlocks audio.
// No username field on purpose: it wouldn't do anything.
function LoginDialog({ onEnter }) {
  return (
    <Centered>
      <StyledWindow title="Welcome" controls={[]}>
        <Body>
          <Keys aria-hidden="true">
            {/* Pixel key, not emoji — an OS-native 🗝️ was the one
                modern pixel on the very first screen of the piece. */}
            <PixelIcon name="key" size={32} />
          </Keys>
          <Text>
            <p>Welcome to Solitaire Alone Together.</p>
            <p>Click OK to log on.</p>
          </Text>
          <Buttons>
            <button type="button" autoFocus onClick={onEnter}>
              OK
            </button>
          </Buttons>
        </Body>
      </StyledWindow>
    </Centered>
  );
}

const Centered = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledWindow = styled(Window)`
  width: 360px;
`;

const Body = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr;
  grid-template-areas:
    "icon text"
    "buttons buttons";
  gap: 12px;
  padding: 14px 16px 12px;
  align-items: center;
`;

const Keys = styled.div`
  grid-area: icon;
  text-align: center;
`;

const Text = styled.div`
  grid-area: text;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Buttons = styled.div`
  grid-area: buttons;
  display: flex;
  justify-content: center;

  & button {
    min-width: 90px;
  }
`;

export default LoginDialog;
